import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useModal } from '../App';
interface FAQItem {
  id: number;
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  id: 1,
  question: 'How long does a roof replacement take?',
  answer: 'Most residential roof replacements are completed in just 1–3 days. Factors like roof size, pitch complexity, and material type can affect the timeline. We always give you a firm schedule upfront — no vague estimates, no surprises.'
}, {
  id: 2,
  question: 'Do you work with insurance companies?',
  answer: 'Yes, absolutely. We are experienced insurance claim specialists. Our team will assess your storm or hail damage, document everything thoroughly, and work directly with your adjuster to make the claims process as smooth as possible for you.'
}, {
  id: 3,
  question: 'What roofing materials do you use?',
  answer: 'We work with all major roofing systems — architectural shingles, metal roofing, tile, flat/TPO, and more. We partner with top manufacturers including GAF, Owens Corning, and CertainTeed, so every material comes with industry-leading warranties.'
}, {
  id: 4,
  question: 'How much does a new roof cost?',
  answer: 'A typical residential roof replacement ranges from $8,000 to $20,000+ depending on size, material, and complexity. We provide free, detailed estimates with transparent line-item pricing — no hidden fees, no pressure. Financing options are also available.'
}, {
  id: 5,
  question: 'Is a free inspection really free?',
  answer: 'Yes — 100% free, no strings attached. One of our certified inspectors will assess your roof, document any issues with photos, and walk you through our findings in plain language. You are never obligated to move forward.'
}, {
  id: 6,
  question: 'What warranty do you offer on your work?',
  answer: "Every ProRoof installation comes with our Lifetime Workmanship Warranty covering labor defects, plus the manufacturer's material warranty (typically 25–50 years depending on the product line). If anything is not right, we will make it right — guaranteed."
}];
export function FAQ() {
  const [openId, setOpenId] = useState<number | null>(1);
  const {
    openModal
  } = useModal();
  const toggle = (id: number) => setOpenId(prev => prev === id ? null : id);
  const left = faqs.filter((_, i) => i % 2 === 0);
  const right = faqs.filter((_, i) => i % 2 !== 0);
  const renderItem = (item: FAQItem) => {
    const isOpen = openId === item.id;
    return <div key={item.id} className="rounded-xl cursor-pointer transition-all duration-200" style={{
      border: isOpen ? '1.5px solid #F59E0B' : '1.5px solid #E2E8F0',
      background: isOpen ? '#FFFBEB' : '#FFFFFF',
      marginBottom: '12px'
    }} onClick={() => toggle(item.id)} data-id="element-55">
        <div className="flex items-start justify-between gap-4 p-5" data-id="element-56">
          <p className="font-semibold leading-snug" style={{
          fontSize: '15px',
          color: isOpen ? '#0F172A' : '#1E293B'
        }} data-id="element-57">
            {item.question}
          </p>
          <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5" style={{
          background: isOpen ? '#F59E0B' : '#F1F5F9'
        }} data-id="element-58">
            {isOpen ? <MinusIcon size={13} color="#FFFFFF" strokeWidth={2.5} data-id="element-59" /> : <PlusIcon size={13} color="#64748B" strokeWidth={2.5} data-id="element-60" />}
          </div>
        </div>
        {isOpen && <div className="px-5 pb-5" style={{
        borderTop: '1px solid #FDE68A',
        paddingTop: '14px'
      }} data-id="element-61">
            <p style={{
          color: '#475569',
          fontSize: '14px',
          lineHeight: '1.7'
        }} data-id="element-62">{item.answer}</p>
          </div>}
      </div>;
  };
  return <section style={{
    background: '#0F172A'
  }} className="py-20 md:py-28" data-id="element-63">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-64">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14" data-id="element-65">
          <div data-id="element-66">
            <p className="uppercase tracking-widest font-semibold mb-3" style={{
            color: '#F59E0B',
            fontSize: '11px',
            letterSpacing: '0.15em'
          }} data-id="element-67">
              Got Questions?
            </p>
            <h2 className="font-black leading-none" style={{
            fontSize: 'clamp(42px, 6vw, 72px)',
            color: '#FFFFFF',
            letterSpacing: '-0.02em'
          }} data-id="element-68">
              Frequently<br data-id="element-69" />Asked
            </h2>
          </div>
          <div className="lg:text-right" data-id="element-70">
            <p style={{
            color: '#64748B',
            fontSize: '14px',
            maxWidth: '280px'
          }} className="lg:ml-auto mb-4" data-id="element-71">
              Still have questions? Our team is available 7 days a week.
            </p>
            {/* "Ask a question" now opens modal */}
            <button onClick={openModal} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold transition-colors" style={{
            background: 'transparent',
            border: '1.5px solid #334155',
            color: '#94A3B8',
            fontSize: '14px',
            cursor: 'pointer'
          }} onMouseEnter={e => {
            const el = e.currentTarget as HTMLButtonElement;
            el.style.borderColor = '#F59E0B';
            el.style.color = '#F59E0B';
          }} onMouseLeave={e => {
            const el = e.currentTarget as HTMLButtonElement;
            el.style.borderColor = '#334155';
            el.style.color = '#94A3B8';
          }} data-id="element-72">
              Ask a question →
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6" data-id="element-73">
          <div data-id="element-74">{left.map(renderItem)}</div>
          <div data-id="element-75">{right.map(renderItem)}</div>
        </div>
      </div>
    </section>;
}